<script setup lang="ts">
import LearnDocPage from '@/components/learn/LearnDocPage.vue';
import LearnDocsShell from '@/components/learn/LearnDocsShell.vue';
</script>

<template>
  <LearnDocsShell>
    <LearnDocPage slug="welcome" />
  </LearnDocsShell>
</template>
